import React, {forwardRef} from 'react'

import {AddUser_Manager} from "../../model/manager"
import Button, {ButtonType} from "../../../../gd-components/buttons/gd-button/gd-button-ui5-new"

type Props = {
    manager     : AddUser_Manager

    onSubmit    : func
}

export default forwardRef(function ModalAddUser_SubmitButton(props: Props, ref: any) {

    const submitButtonIsDisabled    = props.manager.allUsersToAddSelected.length === 0
    const submitButtonLabel         = props.manager.allUsersToAddSelected.length <= 1 ? "Add User" : "Add {0} Users".f(props.manager.allUsersToAddSelected.length)

    return (
        <Button ref         = {ref}
                className   = "w-100"
                type        = {ButtonType.PRIMARY}
                label       = {submitButtonLabel}
                disabled    = {submitButtonIsDisabled}
                onClick     = {props.onSubmit} />
    )
})
